import Vue from 'vue';

Vue.component('cookiebot-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {};
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.cookieContainer = this.$el.querySelector('.cookiebot-container');

        // Make & append cookie script
        const script = document.createElement('script');
        script.setAttribute('data-cookieconsent', 'ignore');
        script.setAttribute('id', 'CookieDeclaration');
        script.setAttribute('src', 'https://consent.cookiebot.com/c179f25f-08e9-4290-8d5f-e5af8740f003/cd.js');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('async', true);
        this.cookieContainer.appendChild(script);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {},
});
